
import React from 'react';
import { Globe } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { toast } from 'sonner';

const LanguageSelector = () => {
  const { i18n } = useTranslation();

  const languages = [
    { code: 'en', label: 'English' },
    { code: 'es', label: 'Español' },
    { code: 'pt', label: 'Português' }
  ];

  const changeLanguage = (langCode: string) => {
    const previousLang = i18n.language;
    i18n.changeLanguage(langCode);
    localStorage.setItem('i18nextLng', langCode);
    
    // Mostrar notificación del cambio de idioma
    const newLangLabel = languages.find(lang => lang.code === langCode)?.label;
    toast.success(`Idioma cambiado a ${newLangLabel}`);
    
    console.log('Language changed from', previousLang, 'to', langCode);
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger className="p-1 rounded-full hover:bg-gray-100 transition-colors">
        <Globe className="w-5 h-5 text-gray-700" />
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        {languages.map((lang) => (
          <DropdownMenuItem
            key={lang.code}
            onClick={() => changeLanguage(lang.code)}
            className={`cursor-pointer ${
              i18n.language === lang.code ? 'bg-gray-100' : ''
            }`}
          >
            {lang.label}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default LanguageSelector;
